import { format } from "date-fns";
import type { PublicationModel } from "../../types/models";

/** An explicit local date also resets an already-mounted calendar's period. */
export function getProjectCalendarHref(folderId: string, nextPostAt?: Date | null, now = new Date()): string {
  const date = nextPostAt && Number.isFinite(nextPostAt.getTime()) ? nextPostAt : now;
  const params = new URLSearchParams({ project: folderId, currentDate: format(date, "yyyy-MM-dd") });
  return `/calendar?${params.toString()}`;
}

/** Preserve the current calendar period, but don't reopen a filtered post inspector. */
export function getUnfilteredCalendarHref(searchParams: URLSearchParams): string {
  const params = new URLSearchParams(searchParams);
  params.delete("project");
  params.delete("publicationId");
  const search = params.toString();
  return search ? `/calendar?${search}` : "/calendar";
}

/** Include history and manual edits whose Auto post marker was cleared. */
export function filterProjectPublications<T extends Pick<PublicationModel, "autoFolderId" | "projectId">>(
  publications: readonly T[],
  folderId: string,
  videoIds: ReadonlySet<string>,
): T[] {
  return publications.filter(publication => publication.autoFolderId === folderId ||
    (publication.projectId != null && videoIds.has(publication.projectId)));
}
